import A11yTabs from 'a11y-tabs';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function timetableTabs() {
    const Selector = {
        CONTAINER: '.tabs',
        TABS: '.tab-list',
        TAB: '.tab-item',
    };

    const cssClass = 'is-visible';

    function init() {
        const tabList = document.querySelectorAll(Selector.TABS);

        // Add tabs functionality
        if(tabList.length) {
            new A11yTabs(Selector.TABS, '[role="tabpanel"]', 0);
        }

        // Display tabs on scroll
        gsap.registerPlugin(ScrollTrigger);

        let container = document.querySelector(Selector.CONTAINER);

        if(!container) {
            return;
        }

        ScrollTrigger.create({
            trigger: Selector.CONTAINER,
            start: 'top 30%',
            end: 'bottom 40%',
            onToggle: () => tabList[0].classList.toggle(cssClass),
        });

        // Refresh ScrollTriger
        const buttons = container.querySelectorAll(Selector.TAB);

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                if(window.innerWidth < 768) {
                    container.scrollIntoView();
                }
                ScrollTrigger.refresh(true);
            });
        })
    }

    init();
}